// Deprecated components
import {
  FormLabel as ChakraFormLabel,
  FormHelperText as ChakraFormHelperText,
  FormErrorMessage as ChakraFormErrorMessage,
} from '@chakra-ui/react';

// Layout Components
export { Box, Flex, Container, Grid, GridItem, SimpleGrid, VStack, Stack, Center, Circle } from '@chakra-ui/react';

/** @deprecated Chakra component. Prefer CoreBox with flexGrow={1} for flex gaps, or fullW/margins/gaps on CoreBox. */
export { Spacer } from '@chakra-ui/react';

// Typography

/** @deprecated Use CoreText from `@vitvio/design-system` instead. */
export { Text } from './components/text';
/** @deprecated Use CoreText from `@vitvio/design-system` instead. */
export { Heading } from './components/text';
export type { TextProps, HeadingProps } from './components/text';

// Button
export { Button } from './components/button';
export type { ButtonProps } from './components/button';

// CoreButton
export { CoreButton } from './components/CoreButton';
export type { ButtonProps as CoreButtonProps } from './components/CoreButton';

// CoreChip
export { CoreChip } from './components/CoreChip';
export type {
  ChipProps as CoreChipProps,
  ChipColorToken,
  ChipSizeToken,
  ChipVariantToken,
} from './components/CoreChip';

// Translation
export { Translation, useTranslatedContent } from './components/translation';
export type { TranslationProps, TranslationValue } from './components/translation';

// Badge
export { Badge } from './components/badge';
export type { BadgeProps } from './components/badge';

// Table
export { Table, Thead, Tbody, Tr, Th, Td, TableContainer } from './components/table';
export type { ThProps, TdProps } from './components/table';

/**
 * @deprecated Use Text from `@vitvio/design-system` instead. Example:
 *   <Text colorToken="fg.muted" font="S_Regular" path="common:labelText" />
 */
export const FormLabel = ChakraFormLabel;

/**
 * @deprecated Use Text from `@vitvio/design-system` instead. Example:
 *   <Text colorToken="fg.muted" font="S_Regular" path="common:helpText" />
 */
export const FormHelperText = ChakraFormHelperText;

/**
 * @deprecated Use Text from `@vitvio/design-system` instead. Example:
 *   <Text colorToken="fg.error" font="S_Regular" path="common:errorText" />
 */
export const FormErrorMessage = ChakraFormErrorMessage;

// Explicit export to expose ChakraFormLabel via the design system
export { ChakraFormLabel };

// Form Components
export {
  ButtonGroup,
  IconButton,
  Select,
  Input,
  InputGroup,
  InputRightElement,
  InputRightAddon,
  FormControl,
  FormErrorIcon,
} from '@chakra-ui/react';

// Link
export { Link } from './components/link';
export type { LinkProps } from './components/link';

// Navigation
export { Menu, MenuButton, MenuList, MenuItem, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';

// Feedback
export {
  Alert,
  AlertIcon,
  Spinner,
  Progress,
  Badge as ChakraBadge,
  Tag,
  TagLabel,
  TagLeftIcon,
  Tooltip,
} from '@chakra-ui/react';

// Overlay
export {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerFooter,
  DrawerBody,
  DrawerCloseButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverHeader,
  PopoverCloseButton,
  PopoverBody,
} from '@chakra-ui/react';

// Media
export { Avatar, Icon } from '@chakra-ui/react';

// Icons - CoreIcon
export { CoreIcon } from './components/CoreIcon';
export type { IconProps as CoreIconProps } from './components/CoreIcon';
export type { IconName } from './icons/types';

// Datepicker - CoreDatepicker
export { CoreDatepicker } from './components/CoreDatepicker';
export type { CoreDatepickerProps } from './components/CoreDatepicker';

// Modal - CoreModal
export { CoreModal } from './components/CoreModal';
export type { CoreModalProps, CoreModalButton } from './components/CoreModal';

// Banner - CoreBanner
export { CoreBanner } from './components/CoreBanner';
export type { CoreBannerProps, CoreBannerButton, CoreBannerType } from './components/CoreBanner';

// TimeSelect
export { TimeSelect } from './components/TimeSelect';
export type { TimeSelectProps, MinuteStep, TimeSelectBound } from './components/TimeSelect';

// EventTimeCard - CoreEventTimeCard
export { CoreEventTimeCard } from './components/CoreEventTimeCard';
export type { CoreEventTimeCardProps } from './components/CoreEventTimeCard';

// Box - CoreBox
export { CoreBox } from './components/CoreBox';
export type { CoreBoxProps } from './components/CoreBox';

// Text - CoreText
export { CoreText } from './components/CoreText';
export type { CoreTextProps } from './components/CoreText';

// Shared types and hooks for spacing/margin/colors/font
export type {
  SpacingValue,
  MarginValue,
  PaddingProps,
  MarginProps,
  ColorProps,
  FontProps,
  TextDecorationProps,
  StyleGroup,
} from './components/helpers';
export { useStylesCss } from './components/helpers';

// Tabs
export { Tabs, TabList, TabPanels, Tab, TabPanel } from './components/tabs';
export type { TabsProps, TabListProps, TabPanelsProps, TabProps, TabPanelProps } from './components/tabs';

// Other
export {
  Portal,
  AbsoluteCenter,
  CloseButton,
  List,
  ListItem,
  Kbd,
  Divider,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Highlight,
} from '@chakra-ui/react';

// Hooks
export {
  useDisclosure,
  useOutsideClick,
  // TODO: deprecated
  useTheme as useChakraTheme,
  useToast,
} from '@chakra-ui/react';

// Provider
export { ChakraProvider, ThemeProvider as ChakraThemeProvider } from '@chakra-ui/react';

// Icons
export { InfoIcon, ChevronRightIcon } from '@chakra-ui/icons';

// Theme utilities
export { extendTheme } from '@chakra-ui/react';

// Types
export type { IconProps, TextProps as ChakraTextProps, HeadingProps as ChakraHeadingProps } from '@chakra-ui/react';

// Themes
// Note: FontToken originates from `typography/types` and is re-exported through `themes/index`.
// Internal design-system files may import it from either path; they resolve to the same type.
export { themes, DEFAULT_THEME, DEFAULT_THEME_DARK } from './themes';
export type { ThemeId, TypographyConfig, FontToken } from './themes';

// Theme Provider and Hook
export { ThemeProvider, useThemeContext, useTheme } from './provider';

export { ThemeWrapper, colors } from './colors';

export * from './themes/types';
